import { SubscriptionTileMode } from 'src/lib/types/subscriptions'

export const TITLE_MAX_LENGTH = 18
export const SUBTITLE_MAX_LENGTH = 25

export const MODE_LABEL_KEY: Record<SubscriptionTileMode, string> = {
  UPI_INTENT: 'payments_tab.tile_mode_upi_intent',
  UPI: 'payments_tab.tile_mode_upi'
}

export const MODE_SUBTITLE_KEY: Record<SubscriptionTileMode, string> = {
  UPI_INTENT: 'payments_tab.tile_mode_upi_intent_subtitle',
  UPI: 'payments_tab.tile_mode_upi_subtitle'
}

export const modeLabelKey = (mode: string) => MODE_LABEL_KEY[mode as SubscriptionTileMode]

export const modeSubtitleKey = (mode: string) => MODE_SUBTITLE_KEY[mode as SubscriptionTileMode]

export const toBEPaymentCard = (card: {
  backgroundColor: string
  borderColor: string
  textColor: string
  iconColor: string
  subtitleColor: string
}) => ({
  background_color: card.backgroundColor,
  border_color: card.borderColor,
  text_color: card.textColor,
  icon_color: card.iconColor,
  subtitle_color: card.subtitleColor
})

export const toBEOfferBadge = (badge: { backgroundColor: string; textColor: string }) => ({
  background_color: badge.backgroundColor,
  text_color: badge.textColor
})
